import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { MainSubCategoryListingFunc } from "./../api/index";
import { useAuth } from "../context/AuthContent";

// FONTAWESOME
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown } from "@fortawesome/free-solid-svg-icons";

export default function AYMenu({ serviceLinks, treatmentLinks }) {
  const { user, cartCount } = useAuth();
  const [categoriesListing, setCategoriesListing] = useState([]);
  function onLinkClick() {
    let MobileMenuDropDown = document.getElementById("menu");
    let MobileMenuBtn = document.querySelector(".btn-show-menu-mobile");

    if (MobileMenuBtn?.classList?.contains("is-active")) {
      MobileMenuBtn.classList.remove("is-active");
    }

    if (MobileMenuDropDown?.classList?.contains("show")) {
      MobileMenuDropDown.classList.remove("show");
    }
  }

  function triggerMobileSubMenu(e) {
    // Find the closest <li> element
    const li = e.currentTarget.closest("li");
    const dropDownIcon = e.currentTarget.closest("svg");
    if (!li) return;
    // console.log(dropDownIcon);

    // Find its child .mega-submenu
    const submenu = li.querySelector(".mega-submenu");
    if (submenu) {
      submenu.classList.toggle("active"); // toggle class to show/hide submenu
    }
    if (dropDownIcon) {
      dropDownIcon?.classList.toggle("mobileMenuDropDownRotate");
    }
  }

  useEffect(() => {
    const fetchData = async () => {
      try {
        const Data = await MainSubCategoryListingFunc();
        if (Data.data.data) {
          setCategoriesListing(Data.data.data);
        }
      } catch (err) {
        console.log(err);
      }
    };

    fetchData();
  }, []);

  return (
    <ul className="menu">
      <li className="mega-menu-item">
        <Link onClick={onLinkClick} to="/about">
          About
        </Link>
      </li>
      <li className="mega-menu-item">
        <Link onClick={onLinkClick} to="/services">
          Services
        </Link>
        <FontAwesomeIcon
          className="mobileMenuDropDown"
          onClick={triggerMobileSubMenu}
          icon={faChevronDown}
        />
        <ul className="mega-submenu">
          {/* FINALISED MENU */}
          {serviceLinks && serviceLinks.length > 0
            ? serviceLinks.map((item, index) => {
                return (
                  <li key={index}>
                    <Link onClick={onLinkClick} to={`/services${item.url}`}>
                      {item.name}
                    </Link>
                  </li>
                );
              })
            : null}
        </ul>
      </li>
      <li className="mega-menu-item menu-hover-custom">
        <Link onClick={onLinkClick} to="/USHAKriya-Wellness">
          Yoga
        </Link>
      </li>
      <li className="mega-menu-item">
        <a>Treatment</a>
        <FontAwesomeIcon
          className="mobileMenuDropDown"
          onClick={triggerMobileSubMenu}
          icon={faChevronDown}
        />
        <ul className="mega-submenu">
          {treatmentLinks && treatmentLinks.length > 0
            ? treatmentLinks.map((item, index) => {
                return (
                  <li key={`${index}-treatment`}>
                    <Link onClick={onLinkClick} to={`/treatments${item.url}`}>
                      {item.name}
                    </Link>
                  </li>
                );
              })
            : null}
        </ul>
      </li>
      <li className="mega-menu-item">
        <Link onClick={onLinkClick} to="/Centers-and-Camps">
          Centers & Camps
        </Link>
      </li>
      <li className="mega-menu-item">
        <Link onClick={onLinkClick} to="/shop">
          Shop
        </Link>
        <FontAwesomeIcon
          className="mobileMenuDropDown"
          onClick={triggerMobileSubMenu}
          icon={faChevronDown}
        />
        <ul className="mega-submenu">
          {/* FINALISED MENU */}
          {categoriesListing && categoriesListing.length > 0
            ? categoriesListing.map((item, index) => {
                return (
                  <>
                    <li key={index}>
                      <Link onClick={onLinkClick} to={`${item.category_url}`}>
                        {item.category_name}
                      </Link>
                    </li>
                    <ul className="Sub_Category_Listing">
                      {item.get_sub_categories?.map((data, Ind) => {
                        return (
                          <li key={Ind}>
                            <Link
                              className="Sub_Category_Menu_Link"
                              to={`${item.category_url}${data?.category_url}`}
                            >
                              {data?.category_name}
                            </Link>
                          </li>
                        );
                      })}
                    </ul>
                  </>
                );
              })
            : null}
        </ul>
      </li>
      <li className="mega-menu-item">
        <Link onClick={onLinkClick} to="/team">
          Dhara Parivar
        </Link>
      </li>
      <li className="mega-menu-item">
        <Link onClick={onLinkClick} to="/blog">
          Feedback & News
        </Link>
      </li>
      <li className="mega-menu-item">
        <Link onClick={onLinkClick} to="/contact">
          Contact
        </Link>
      </li>
      <li className="mega-menu-item">
        {!user ? (
          <Link onClick={onLinkClick} to="/login">
            Register/Login
          </Link>
        ) : (
          <Link onClick={onLinkClick} to="/dashboard">
            {user.name}
          </Link>
        )}
      </li>
      <li className="cart-icon-menu mega-menu-item noHoverMenu">
        <Link to="/cart" className="cartLink">
          <p>Cart</p>
          <div className="d-inline">
            <i class="fa-solid fa-cart-arrow-down"></i>
            <span>{cartCount}</span>
          </div>
        </Link>
      </li>
    </ul>
  );
}
